module.exports = __webpack_public_path__ + "img/pt-root-03.fb4524dc.svg";